import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux'

import { persistor, store } from './redux/store';
import './index.css';
import './antd-table.css';
import "react-datepicker/dist/react-datepicker.css";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Toaster } from 'react-hot-toast';
import './styling/report-dashboard.css';
import './styling/report-datasets.css';
import './styling/report-reports.css'

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { PersistGate } from 'redux-persist/integration/react';

// ReactDOM.render(
//   <HelmetProvider>
//     <BrowserRouter>
//         <App />
//       <Toaster />
//     </BrowserRouter>
//   </HelmetProvider>,
//   document.getElementById('root')
// );

// window.renderDogs = (containerId, history) => {
//   ReactDOM.render(
//     <HelmetProvider>
//       <BrowserRouter history={history} >
//         <App history={history} />
//         <Toaster />
//       </BrowserRouter>
//     </HelmetProvider>,
//     document.getElementById(containerId)
//   );
// };

// window.unmountDogs = containerId => {
//   ReactDOM.unmountComponentAtNode(document.getElementById(containerId));
// };

if (!document.getElementById('Dogs-container')) {
  ReactDOM.render(
    <HelmetProvider>
      <BrowserRouter>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <App />
          </PersistGate>          
        </Provider>        
        <Toaster />
      </BrowserRouter>
    </HelmetProvider>,
    document.getElementById('root')
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
